const codeViewTypes = {
  Unset: -1,
  AnadirComentario: 1,
  InactivarEstudiante: 2,
  ReactivarEstudiante: 3,
  EgresarEstudiante: 4,
  PreRegistroEstudiante: 5,
  Transfer: 6,
  //Pei - Referral
  ReferralManagment: 7,
};

export default codeViewTypes;
